import {NgModule} from '@angular/core';
import {ApolloModule} from 'apollo-angular';


@NgModule({
    exports: [ApolloModule],
})
export class GraphQLModule {
}
